import React from "react";
import { User2 } from "lucide-react";

const Avatar = ({
  src,
  alt = "User Avatar",
  size = 50,
  className = "",
  style = {},
  variant = "default", // default, bordered
  ...props
}) => {
  const avatarSize = {
    width: `${size}px`,
    height: `${size}px`,
  };

  const combinedStyle = {
    ...avatarSize,
    ...style,
  };

  // Variant-based styling
  const getBorderClasses = () => {
    switch (variant) {
      case "bordered":
        return "border-2 border-zinc-200";
      default:
        return "";
    }
  };

  return (
    <div
      className={`relative rounded-full overflow-hidden cursor-pointer transition-all duration-200 ease-in-out ${getBorderClasses()} ${className}`}
      style={combinedStyle}
      {...props}
    >
      {src ? (
        <img
          className="w-full h-full rounded-full object-cover transition-all duration-200 ease-in-out hover:brightness-75"
          src={src}
          alt={alt}
        />
      ) : (
        <div className="w-full h-full rounded-full bg-zinc-100  flex items-center justify-center transition-colors duration-200 ease-in-out hover:bg-zinc-200">
          <User2
            size={Math.max(20, size * 0.5)}
            className="text-zinc-500 transition-colors duration-200 ease-in-out hover:text-zinc-600"
          />
        </div>
      )}
    </div>
  );
};

export default Avatar;
